import './LicensesTableRowActivations.scss';
import * as React from 'react';
import * as Core from 'components/core';
import { License, LicenseSeat, LicenseSeatActivation } from 'types/license';
type Props = {
  license: License;
  activations: Array<
    {
      seat: LicenseSeat;
    } & LicenseSeatActivation
  >;
};
export default class LicensesTableRowActivations extends React.Component<Props> {
  render() {
    const { license, activations } = this.props;
    if (activations.length === 0) {
      return null;
    }
    return (
      <ul className="LicensesTableRowActivations">
        {activations.map((activation) => (
          <li
            className="LicensesTableRowActivations-activation"
            key={activation.ID}
          >
            <div>
              <Core.MonospacedText>
                {activation.MachineID || ''}
              </Core.MonospacedText>
            </div>
            <div>{activation.MachineName || ''}</div>
            <div>{activation.ComputerModel || ''}</div>
            <div>
              {license.AppVersion < 5 &&
                license.Terms !== 'site' &&
                `(${activation.seat.Disposition})`}
              {activation.Note}
            </div>
          </li>
        ))}
      </ul>
    );
  }
}
